import * as Yup from 'yup/lib'
import * as validations from 'modules/SharedSales/constants/validations'

export const DeviceTypeSelectionSchema = {
  saleChannel: Yup.string().required(validations.REQUIRED_FIELD_TEXT),
  deviceType: Yup.string().required(validations.REQUIRED_FIELD_TEXT),
}
